<template>
  <div class="salaries-content-group-recap">
    <SalariesContentGroupHeader group-id="recap" />
    <SalariesContentBlock group-id="recap">
      <h3 slot="header" class="salaries-content-group-recap__header">
        Only 47% of sales teams
        <br />
        hit Quota in 2021
      </h3>
      <div slot="header2" class="salaries-content-group-recap__header2">Percentage of Sales Team that Hit Quota</div>
      <div slot="table" class="salaries-content-group-recap__table">
        <div class="salaries-content-group-recap__table-col">
          <div class="salaries-content-group-recap__table-col-inner">
            <Table1Svg
              alt="Percentage of Sales Team that Hit Quota broken down by Sales Team Size"
              class="salaries-content-group-recap__table-img"
            />
          </div>
          <div class="salaries-content-group-recap__table-col-inner">
            <Table2Svg
              alt="Percentage of Sales Team that Hit Quota broken down by Company Segment: SMB, Mid Market, Enterprise"
              class="salaries-content-group-recap__table-img"
            />
          </div>
        </div>
        <div class="salaries-content-group-recap__table-col">
          <h4 class="salaries-content-group-recap__table-text-header">It is easier to sell with a larger sales team</h4>
          <p class="salaries-content-group-recap__table-text">
            Companies with over 100+ reps did the best, with 55% of those larger teams hitting quota.
          </p>
          <h4 class="salaries-content-group-recap__table-text-header">Be cautious at Series B-D startups</h4>
          <p class="salaries-content-group-recap__table-text">
            Scaling sales teams (26-100 reps) did the worst, with only 44% of them hitting quota.
          </p>
        </div>
      </div>
    </SalariesContentBlock>
    <SalariesContentBlock group-id="recap">
      <div slot="description" class="salaries-content-group-recap__description">
        On the best sales teams, 75%+ of members hit quota.
        <br class="keep" />
        Unfortunately, this is extremely rare in sales.
      </div>
      <h3 slot="header" class="salaries-content-group-recap__header">
        Only 1 in 4 sales teams had
        <br />
        75%+ of their members hit Quota
      </h3>
      <div slot="table" class="salaries-content-group-recap__table">
        <div class="salaries-content-group-recap__table-col">
          <div class="salaries-content-group-recap__table-col-inner">
            <Table3Svg class="salaries-content-group-recap__table-img" />
          </div>
          <div class="salaries-content-group-recap__table-col-inner">
            <Table4Svg class="salaries-content-group-recap__table-img" />
          </div>
        </div>
        <div class="salaries-content-group-recap__table-col">
          <h4 class="salaries-content-group-recap__table-text-header">Go big, or go small</h4>
          <p class="salaries-content-group-recap__table-text">
            Companies with fewer than 10, or more than 100 sales reps had the most successful teams.
          </p>
        </div>
      </div>
    </SalariesContentBlock>
    <SalariesContentBlock group-id="recap">
      <h3 slot="header" class="salaries-content-group-recap__header">
        54% of sales reps missed
        <br />
        Quota in 2021
      </h3>
      <div slot="header2" class="salaries-content-group-recap__header2">Average tenure in sales is declining</div>
      <div slot="table" class="salaries-content-group-recap__table">
        <div class="salaries-content-group-recap__table-col">
          <div class="salaries-content-group-recap__table-col-inner">
            <Table5Svg class="salaries-content-group-recap__table-img-flat" />
          </div>
          <div class="salaries-content-group-recap__table-col-inner" style="max-width: 360px">
            <h4 class="salaries-content-group-recap__table-text-header">
              Sales turnover is higher than any other industry
            </h4>
            <p class="salaries-content-group-recap__table-text">
              Growing number of open sales roles, higher pay, and unrealistic quotas are driving more sales reps to
              leave their jobs.
            </p>
          </div>
        </div>
      </div>
    </SalariesContentBlock>
  </div>
</template>

<script>
import SalariesContentGroupHeader from './SalariesContentGroupHeader.vue';
import SalariesContentBlock from './SalariesContentBlock.vue';
import Table1Svg from './images/table1.vue.svg';
import Table2Svg from './images/table2.vue.svg';
import Table3Svg from './images/table3.vue.svg';
import Table4Svg from './images/table4.vue.svg';
import Table5Svg from './images/table5.vue.svg';

export default {
  name: 'SalariesContentGroupRecap',
  components: {
    SalariesContentBlock,
    SalariesContentGroupHeader,
    Table1Svg,
    Table2Svg,
    Table3Svg,
    Table4Svg,
    Table5Svg,
  },
};
</script>

<style lang="scss" scoped>
.salaries-content-group-recap {
  &__header {
    background: linear-gradient(87.2deg, #1b447f -9.58%, #5f86d1 104.83%), linear-gradient(0deg, #fff, #fff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 48px;
  }

  &__header2 {
    margin-bottom: 16px;
  }

  &__header2,
  &__description {
    background: linear-gradient(87.14deg, #1b447f 0.84%, #5f86d1 160.69%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &__table {
    flex-direction: column;
    justify-content: space-between;
    width: 100%;

    @include mq('lg') {
      display: flex;
      flex-direction: row;
    }
  }

  &__table-col-inner {
    & + & {
      margin-top: 8px;
      margin-left: 0;

      @include mq('sm') {
        margin-top: 0;
        margin-left: 50px;
      }

      @include mq('lg') {
        margin-left: 0;
      }
    }
  }

  &__table-col {
    &:first-child {
      flex-grow: 1;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;

      @include mq('sm') {
        flex-direction: row;
      }

      @include mq('lg') {
        justify-content: space-between;
      }
    }

    & + &:last-child {
      margin: 16px 0 0;
      flex-shrink: 0;
      flex-basis: 361px;

      @include mq('lg') {
        margin: 0 0 0 71px;
      }
    }
  }

  &__table-img,
  &__table-img-flat {
    border-radius: 16px;
    overflow: hidden;
    filter: drop-shadow(0 34px 56px rgba(0, 0, 0, 0.12));
    width: 100%;
    height: auto;

    @include mq('sm') {
      width: auto;
    }
  }

  &__table-img-flat {
    border-radius: 0;
  }

  &__table-text-header {
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: -0.5px;
    margin-bottom: 8px;
    background: linear-gradient(87.2deg, #1b447f -9.58%, #5f86d1 104.83%), linear-gradient(0deg, #fff, #fff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &__table-text + &__table-text-header {
    margin-top: 32px;
  }

  &__table-text {
    font-size: 16px;
    line-height: 30px;
    color: #45454a;
  }
}
</style>
